<template>
  <!-- 首页 -->
  <div class="homePage">
    <!-- 头部 -->
    <headerNav id="headerNav" activeIndex="home"></headerNav>
    <!-- 轮播图 -->
    <bannerNav
      :carousel="info.carousel"
      :Mcarousel="info.Mcarousel"
    ></bannerNav>
    <div class="homePagePc pc">
      <!-- 功效性植物复方原液标题 -->
      <div class="maxWidth" style="text-align: center; margin: 66px auto 69px">
        <div style="font-size: 41px; margin-bottom: 17px; font-weight: 400">
          <span style="color: #3f6b33">COMPOUND</span>
          <span style="color: #4b4b4b"> LIQUOR</span>
        </div>
        <div
          style="
            font-size: 41px;
            color: #353535;
            margin-bottom: 24px;
            line-height: 40px;
            font-weight: 400;
          "
        >
          功效性植物复方原液原料
        </div>
        <div
          style="
            font-size: 18px;
            color: #000000;
            margin-bottom: 69px;
            line-height: 19px;
          "
          class="ql-editor"
          v-html="productInfo.configValue"
        ></div>
      </div>
      <!-- 功效性植物复方原液内容 -->
      <div class="maxWidth productNav">
          <template  v-for="(item, index) of productList">
            <div class="product" v-if="item.name.indexOf('黄家圣幸 5 号') === -1">
            <img :src="getUrlPrefix(item.images)" style="width: 100%" alt="" />
            <div class="productText">
              <div v-html="item.name"></div>
              <div class="moreBtn" @click="goProductDetail(item.id)">
                了解更多
              </div>
            </div>
          </div>
          </template>
        <div class="clear"></div>
      </div>
      <!-- 科研优势 -->
      <div id="advantages">
        <div
          class="advantages showList"
          :style="advantagesShow ? '' : 'opacity:0'"
        >
          <div class="advantagesbg">
            <img
              :src="getUrlPrefix(kyAdvantages.configValue)"
              style="width: 100%"
              alt=""
            />
          </div>
          <div
            class="advantages-content"
            style="padding-top: 130px; overflow: hidden"
          >
            <div
              class="advantages-content-text animal"
              style="margin-left: 20px"
              :style="`margin-right: ${advantagesShow ? '43' : '3017'}px;`"
            >
              <p
                style="
                  color: #fff;
                  font-weight: 400;
                  line-height: 36px;
                  font-size: 36px;
                  margin-bottom: 28px;
                  margin-top: -50px;
                  width: 489px;
                "
              >
                TECHNICAL ADVANTAGES
              </p>
              <p
                style="
                  color: #fff;
                  font-weight: 400;
                  line-height: 45px;
                  font-size: 45px;
                  margin-bottom: 52px;
                "
              >
                科研优势
              </p>
              <div v-for="(item, index) in brandAdvantagesList" :key="index">
                <p
                  style="
                    color: #fff;
                    font-size: 29px;
                    line-height: 29px;
                    margin-bottom: 53px;
                  "
                >
                  {{ index + 1 || "" }}.{{ item.title || "" }}
                </p>
              </div>
            </div>
            <div class="advantages-content-img" style="margin-left: 100px">
              <div
                style="width: 250px"
                v-for="(item, index) in brandAdvantagesList"
                :key="index"
              >
                <div class="img">
                  <img
                    :src="getUrlPrefix(item.images)"
                    style="width: 100%"
                    alt=""
                  />
                </div>
                <div class="content">{{ item.remark || "" }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 介绍 -->
      <div
        class="maxWidth"
        id="introduce"
        style="text-align: center; margin: 66px auto 69px"
      >
        <div
          class="animal"
          style="
            font-size: 41px;
            margin-bottom: 17px;
            width: 1286px;
            overflow: hidden;
          "
          :style="`${introduceShow ? '' : 'margin-right:-3017px'};`"
        >
          <span style="font-weight: 700; color: #3f6b33">御方汇 </span
          ><span style="font-weight: 400; color: #353535">— 始于中医世家</span>
        </div>
        <div
          style="
            font-size: 20px;
            color: #353535;
            margin-bottom: 69px;
            line-height: 38px;
            width: 1286px;
          "
          class="animal ql-editor"
          :style="`${introduceShow ? '' : 'transform: translateX(-2000px)'};`"
          v-html="transform.configValue"
        ></div>
        <div
          class="button1"
          @click="goAbout"
          style="
            margin: 0 auto;
            font-size: 18px;
            cursor: pointer;
            width: 176px;
            height: 45px;
            line-height: 45px;
            border-radius: 8px;
          "
          :style="`${introduceShow ? '' : 'transform: translateX(-2000px);'}${
            animalShow ? 'transition: all 2.5s;' : ''
          }`"
        >
          了解我们 →
        </div>
        <div
          style="width: 100%; margin-top: 53px; transition: all 5s"
          :style="`${introduceShow ? '' : 'opacity:0'};`"
        >
          <img src="@/assets/aboutus.png" style="width: 100%" alt="" />
        </div>
      </div>
      <!-- 品牌荣誉 -->
      <div class="maxWidth" style="text-align: center; margin: 66px auto 69px">
        <div style="font-size: 41px; margin-bottom: 17px; font-weight: 400">
          <span style="color: #3f6b33">BRAND HONORS</span>
        </div>
        <div
          style="
            font-size: 41px;
            color: #353535;
            margin-bottom: 24px;
            line-height: 40px;
            font-weight: 400;
          "
        >
          品牌荣誉
        </div>
      </div>
      <!-- 品牌荣誉列表 -->
      <div class="zsBar maxWidth">
        <div class="zs" v-for="(item, index) of zsList" :key="index">
          <img :src="getUrlPrefix(item.images)" style="width: 100%" alt="" />
          <div class="zsText">
            <div v-html="item.name"></div>
          </div>
        </div>
      </div>
      <div
        class="button1"
        @click="goHonors"
        style="
          margin: 0 auto;
          font-size: 18px;
          cursor: pointer;
          width: 176px;
          height: 45px;
          line-height: 45px;
          border-radius: 8px;
          text-align: center;
          margin-top: 28px;
          margin-bottom: 28px;
        "
      >
        更多荣誉 →
      </div>
      <!-- 合作伙伴 -->
      <div
        style="background: #719468; position: relative; padding: 60px 0px 41px"
        id="huoban"
      >
        <div style="text-align: center">
          <span
            class="line"
            style="width: 141px; border-top: 1px solid #fff"
          ></span>
          <span class="txt Regular" style="color: #fefefe; font-size: 26px"
            >合作伙伴</span
          >
          <span
            class="line"
            style="width: 141px; border-top: 1px solid #fff"
          ></span>
        </div>

        <div
          class="partners maxWidth"
          style="width: 1370px; display: flex; align-items: center"
        >
          <div
            style="
              width: 50px;
              border: 1px solid #fff;
              border-radius: 50px;
              height: 50px;
              text-align: center;
            "
            @click="toLeft"
            v-if="this.carouselList.length > 6"
          >
            <i
              class="el-icon-arrow-left"
              style="color: #fff; font-size: 28px; line-height: 50px"
            ></i>
          </div>
          <div style="overflow: hidden; width: 1170px; margin: 0 50px">
            <div
              style="display: -webkit-box; width: 1170px"
              class="animal"
              :style="`transform:translateX(${left}px);`"
            >
              <div
                class="partners-img"
                v-for="(item2, index2) of carouselList"
                :key="index2"
                :class="huobanShow ? 'bottomtoTop' : ''"
                :style="`animation-duration: ${0.1 * (index2 + 1) + 1}s;${
                  huobanShow ? '' : 'opacity:0'
                }`"
              >
                <img
                  :src="getUrlPrefix(item2.images)"
                  class="enlarge"
                  style="width: 100%"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div
            style="
              width: 50px;
              border: 1px solid #fff;
              border-radius: 50px;
              height: 50px;
              text-align: center;
            "
            @click="toRight"
            v-if="this.carouselList.length > 6"
          >
            <i
              class="el-icon-arrow-right"
              style="color: #fff; font-size: 28px; line-height: 50px"
            ></i>
          </div>
        </div>
      </div>
      <!-- 学术研究 -->
      <div style="background: #eef2f5">
        <div
          class="maxWidth"
          style="margin: 0 auto; width: 1200px; padding: 87px 10px 69px"
          id="academic"
        >
          <div
            style="
              text-align: center;
              font-size: 41px;
              line-height: 41px;
              color: #3f6b33;
              margin-bottom: 19px;
            "
            class="Regular"
          >
            ACADEMIC RESEARCH
          </div>
          <div
            style="
              text-align: center;
              font-size: 41px;
              color: #313131;
              line-height: 41px;
              margin-bottom: 45px;
            "
            class="Regular"
          >
            学术研究
          </div>
          <div>
            <div
              style="
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
              "
            >
              <div
                v-for="(item, index) of lwList"
                :key="index"
                class="lwList"
                @click="goLwDetail(item)"
              >
                <div style="width: 26px; height: 26px; margin-right: 10px">
                  <img
                    src="@/assets/pdf.png"
                    style="width: 100%; height: 100%"
                    alt=""
                  />
                </div>
                <div class="lwListTitle">{{ item.title }}</div>
              </div>
            </div>
          </div>
          <div
            class="button1"
            @click="goAcademic"
            style="
              margin: 0 auto;
              font-size: 18px;
              cursor: pointer;
              width: 176px;
              height: 45px;
              line-height: 45px;
              border-radius: 8px;
              text-align: center;
              margin-top: 48px;
            "
          >
            查看更多 →
          </div>
        </div>
      </div>

      <!-- 新闻中心 -->
      <div class="maxWidth" style="margin: 87px auto 69px" id="news">
        <div
          style="
            text-align: center;
            font-size: 41px;
            line-height: 41px;
            color: #3f6b33;
            margin-bottom: 19px;
          "
          class="Regular"
        >
          NEWS CENTER
        </div>
        <div
          style="
            text-align: center;
            font-size: 41px;
            color: #313131;
            margin-bottom: 74px;
            line-height: 41px;
          "
          class="Regular"
        >
          新闻中心
        </div>
        <div style="display: flex; align-items: center" class="newNav">
          <div style="flex: 1; position: relative" class="newsCarouseNav">
            <div
              style="
                position: absolute;
                bottom: 100px;
                right: 10px;
                z-index: 100;
                display: flex;
                align-items: center;
              "
            >
              <div
                v-for="(items, indexs) of newsCarouselList"
                :key="indexs"
                style="
                  width: 14px;
                  height: 14px;
                  border-radius: 50px;
                  margin-left: 8px;
                  cursor: pointer;
                "
                :style="
                  newNum === indexs ? `background:#719468;` : `background:#ccc;`
                "
                @click.stop="switchNews(indexs)"
              ></div>
            </div>
            <div
              v-for="(item, index) of newsCarouselList"
              :key="index"
              class="newsCarouse"
              style="width: 100%"
              :style="
                newNum === index
                  ? `opacity: 1;`
                  : `position:absolute;top:0;opacity: 0;`
              "
            >
              <div>
                <div
                  style="position: relative; animation-duration: 0s"
                  :class="newNum === index ? `leftToCenter` : `centerToRight`"
                  :style="
                    newNum === index
                      ? `z-index:2;`
                      : `transform: translateX(100px);overflow:hidden;z-index:1;`
                  "
                >
                  <img
                    :src="getUrlPrefix(item.images)"
                    @click="goNewsDetail(item.id)"
                    style="width: 655px; height: 407px"
                    alt=""
                  />
                </div>

                <div
                  class="title Regular"
                  style="cursor: pointer"
                  @click.stop="goNewsDetail(item.id)"
                >
                  {{ item.title || "" }}
                </div>
                <div style="display: flex; align-items: center">
                  <div
                    style="
                      flex: 1;
                      display: -webkit-box;
                      -webkit-box-orient: vertical;
                      -webkit-line-clamp: 2;
                      overflow: hidden;
                      color: #a1a1a1;
                    "
                  >
                    {{ item.description || "" }}
                  </div>
                  <div
                    style="
                      width: 160px;
                      text-align: right;
                      font-size: 36px;
                      color: #719468;
                    "
                  >
                    {{ item.releaseTime.slice(5, 11) || "" }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="margin-left: 66px">
            <div>
              <div
                v-for="(item, index) of newsList"
                :key="index"
                class="newList"
                @click="goNewsDetail(item.id)"
              >
                <div style="width: 645px">
                  <div class="date">{{ item.releaseTime || "" }}</div>
                  <div class="title">
                    <div class="name Regular">{{ item.title || "" }}</div>
                  </div>
                  <div class="content">
                    {{ item.description || "" }}
                  </div>
                </div>
              </div>
            </div>
            <div
              class="clickBtn"
              @click="goNews"
              style="
                float: right;
                width: 164px;
                height: 41px;
                text-align: center;
                line-height: 41px;
                cursor: pointer;
                border-radius: 8px;
                color: #fff;
                margin-top: 20px;
                background: #719468;
                font-size: 18px;
              "
            >
              更多资讯 →
            </div>
          </div>
        </div>
      </div>
      <!-- 视频中心 -->
      <div class="maxWidth" style="margin: 87px auto 69px">
        <div
          style="
            text-align: center;
            font-size: 41px;
            line-height: 41px;
            color: #3f6b33;
            margin-bottom: 19px;
          "
          class="Regular"
        >
          VIDEO CENTER
        </div>
        <div
          style="
            text-align: center;
            font-size: 41px;
            color: #313131;
            margin-bottom: 74px;
            line-height: 41px;
          "
          class="Regular"
        >
          视频中心
        </div>
        <div class="display-flex" style="justify-content: space-around">
          <div
            style="width: 573px; cursor: pointer"
            v-for="(item, index) of videoList"
            :key="index"
            @click="goVideoDetail(item.id)"
          >
            <div style="position: relative">
              <img
                :src="getUrlPrefix(item.coverImage)"
                style="width: 100%"
                alt=""
              />
              <img
                src="@/assets/mobile/video.png"
                style="width: 30%; position: absolute; top: 120px; left: 35%"
                alt=""
              />
            </div>
            <li
              style="
                height: 76px;
                line-height: 76px;
                width: 535px;
                padding: 0 20px;
                color: #fff;
                text-align: center;
                background: #719468;
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <div
                style="
                  width: 8px;
                  height: 8px;
                  background: #fff;
                  border-radius: 50px;
                  margin-right: 6px;
                "
              ></div>
              <div
                class="clickBtn"
                style="
                  font-size: 21px;
                  margin-right: 17px;
                  cursor: pointer;
                  display: -webkit-box;
                  max-width: 400px;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 1;
                  overflow: hidden;
                "
              >
                {{ item.title || "" }}
              </div>
              <div style="font-size: 17px; width: 110px">
                {{ item.releaseTime || "" }}
              </div>
            </li>
          </div>
        </div>
        <div
          class="button1"
          @click="goVideoList"
          style="
            margin: 0 auto;
            font-size: 18px;
            cursor: pointer;
            width: 176px;
            height: 45px;
            line-height: 45px;
            border-radius: 8px;
            text-align: center;
            margin-top: 58px;
          "
        >
          了解我们 →
        </div>
      </div>

      <!-- 底部 -->
      <RightBar></RightBar>
    </div>
    <div class="homePageM mobile">
      <!-- 大标题 -->
      <div style="margin-top: 0.3rem; text-align: center" id="advantagesM">
        <div
          style="
            font-size: 0.32rem;
            line-height: 1.4;
            color: #ddd;
            font-weight: 400;
            font-family: 'Proxima-Bold', sans-serif;
          "
        >
          COMPOUND LIQUOR
        </div>
        <div
          style="color: #0f3a3c; font-weight: 600; margin-top: -4px"
          class="fzTitle"
        >
          功效性植物复方原液原料
        </div>
      </div>
      <!-- 列表内容 -->
      <div>
        <div class="productNav" style="min-height: 5rem">
          <div
            class="product bottomtoTop"
            :style="`animation-duration:${0.5 + index * 0.2}s;`"
            v-for="(item, index) of productList"
            :key="index"
          >
            <img :src="getUrlPrefix(item.images)" style="width: 100%" alt="" />
            <div class="productText">
              <div v-html="item.name"></div>
              <div class="moreBtn" @click="goProductDetail(item.id)">
                了解更多
              </div>
            </div>
          </div>
        </div>
        <!-- <div
            class="moreBtn"
            @click="goProduct"
            style="margin: 0 auto; font-size: 0.14rem;text-align: center;"
          >
            了解我们 →
          </div> -->
      </div>
      <!-- 简介 -->
      <div
        id="introduceM"
        style="
          text-align: center;
          margin: 0.48rem 0.2rem 0.21rem;
          min-height: 3rem;
        "
      >
        <div v-if="introduceShow" class="bottomtoTop">
          <div style="font-size: 0.26rem; margin-bottom: 0.17rem">
            <span style="font-weight: 700; color: #3f6b33">御方汇 </span
            ><span style="font-weight: 400; color: #353535"
              >— 始于中医世家</span
            >
          </div>
          <div
            style="
              font-size: 0.166rem;
              color: #353535;
              margin-bottom: 0.14rem;
              line-height: 0.28rem;
              text-align: left;
            "
            class="editor"
            v-html="transform.configValue"
          ></div>
          <div
            class="moreBtn"
            @click="goAbout"
            style="margin: 0 auto; font-size: 0.14rem"
          >
            了解我们 →
          </div>
          <!-- <div style="width: 100%; margin-top: 53px; transition: all 5s">
            <img src="@/assets/aboutus.png" style="width: 100%" alt="" />
          </div> -->
        </div>
      </div>
      <!-- 科研优势 -->
      <div
        style="position: relative; background: #f5faf4; min-height: 3rem"
        id="techniclaM"
      >
        <div v-if="techniclaShow">
          <div
            style="width: 100%; position: absolute; top: 0; left: 0; z-index: 1"
          >
            <img src="@/assets/mobile/bg1.png" style="width: 100%" alt="" />
          </div>
          <div
            style="padding: 0.37rem 0.39rem 0; z-index: 100; position: relative"
          >
            <div
              class="bottomtoTop"
              style="margin-bottom: 0.08rem; font-size: 0.1rem; color: #000"
            >
              TECHNICAL ADVANTAGES
            </div>
            <div
              class="Regular bottomtoTop"
              style="
                animation-duration: 0.2s;
                margin-bottom: 0.23rem;
                font-size: 0.2rem;
                color: #000;
              "
            >
              科研优势
            </div>
            <div
              v-for="(item, index) in brandAdvantagesList"
              class="bottomtoTop"
              :key="index"
              style="
                color: #fff;
                display: table;
                padding: 0 0.05rem;
                background: #3f6b33;
                font-size: 0.16rem;
                line-height: 0.28rem;
                margin-bottom: 0.12rem;
              "
              :style="`animation-duration:${0.5 + index * 0.1}s;`"
            >
              {{ index + 1 || "" }}.{{ item.title || "" }}
            </div>
          </div>
          <div
            class="advantages-content-img"
            style="z-index: 100; position: relative"
          >
            <div
              class="bottomtoTop"
              :style="`animation-duration:${0.6 + index * 0.2}s;`"
              v-for="(item, index) in brandAdvantagesList"
              :key="index"
            >
              <div class="img">
                <img
                  :src="getUrlPrefix(item.images)"
                  style="width: 100%"
                  alt=""
                />
              </div>
              <div
                style="font-size: 0.146rem; text-align: left; margin-top: 0.1rem"
                class="content"
              >
                {{ item.remark || "" }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 品牌荣誉 -->
      <div style="margin-top: 0.3rem; text-align: center">
        <div
          style="
            font-size: 0.34rem;
            line-height: 1.4;
            color: #ddd;
            font-weight: 400;
            font-family: 'Proxima-Bold', sans-serif;
          "
        >
          BRAND HONORS
        </div>
        <div
          style="
            font-size: 0.26rem;
            color: #0f3a3c;
            font-weight: 600;
            margin-top: -4px;
          "
        >
          品牌荣誉
        </div>
      </div>
      <div style="padding: 0.2rem 0.2rem 0.1rem">
        <div class="zsList">
          <div
            v-for="(item, index) of zsList"
            :key="index"
            class="img"
            style="width: 46%; margin-bottom: 20px"
          >
            <div class="Regular" style="color: #719468; width: 100%">
              <img
                :src="getUrlPrefix(item.images)"
                style="width: 100%"
                alt=""
              />
            </div>
            <div
              class="Regular"
              style="
                text-align: center;
                margin-top: 10px;
                font-size: 15px;
                line-height: 1.4;
                color: #434343;
              "
            >
              {{ item.name }}
            </div>
          </div>
        </div>

        <div style="text-align: center">
          <div
            class="moreBtn"
            @click="goHonors"
            style="margin: 0 auto 10px; font-size: 0.14rem; text-align: center"
          >
            更多荣誉 →
          </div>
        </div>
      </div>
      <!-- 合作伙伴 -->
      <div
        style="
          background: #719468;
          position: relative;
          padding: 0.15rem 0px 0.1rem;
        "
        id="huoban"
      >
        <div style="text-align: center">
          <span
            class="line"
            style="width: 0.75rem; border-top: 1px solid #fff"
          ></span>
          <span class="txt Regular" style="color: #fefefe; font-size: 0.18rem"
            >合作伙伴</span
          >
          <span
            class="line"
            style="width: 0.75rem; border-top: 1px solid #fff"
          ></span>
        </div>

        <div
          class="partners maxWidth"
          style="
            width: calc(100% - 0.4rem);
            display: flex;
            align-items: center;
            padding: 0.1rem 0.2rem;
          "
        >
          <div
            style="width: 0.14rem; height: 0.2rem; text-align: center"
            @click="toLeft"
            v-if="this.carouselList.length > 6"
          >
            <i
              class="el-icon-arrow-left"
              style="color: #fff; font-size: 0.2rem"
            ></i>
          </div>
          <div
            style="overflow: hidden; margin: 0 0.08rem; width: 100%"
            @touchstart="touchStart($event)"
            @touchmove="touchMove($event)"
            @touchend="touchEnd($event)"
          >
            <div
              style="display: -webkit-box; width: 100%"
              class="animal"
              :style="`transform:translateX(${left}px);`"
            >
              <div
                class="partners-img hzhb"
                v-for="(item2, index2) of carouselList"
                :key="index2"
                :class="huobanShow ? 'bottomtoTop' : ''"
                :style="`animation-duration: ${0.1 * (index2 + 1) + 1}s;`"
              >
                <img
                  :src="getUrlPrefix(item2.images)"
                  class="enlarge"
                  style="width: 100%"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div
            style="width: 0.14rem; height: 0.2rem; text-align: center"
            @click="toRight"
            v-if="this.carouselList.length > 6"
          >
            <i
              class="el-icon-arrow-right"
              style="color: #fff; font-size: 0.2rem"
            ></i>
          </div>
        </div>
      </div>
      <!-- 学术研究 -->
      <div style="margin-top: 0.3rem; text-align: center">
        <div
          style="
            font-size: 0.34rem;
            line-height: 1.4;
            color: #ddd;
            font-weight: 400;
            font-family: 'Proxima-Bold', sans-serif;
          "
        >
          ACADEMIC RESEARCH
        </div>
        <div
          style="
            font-size: 0.26rem;
            color: #0f3a3c;
            font-weight: 600;
            margin-top: -4px;
          "
        >
          学术研究
        </div>
      </div>
      <div style="padding: 0.2rem 0.2rem 0.1rem">
        <div v-for="(item, index) of lwList" :key="index" class="lwListNav" @click="goLwDetail(item)">
          <div style="width: 0.16rem; margin-right: 0.04rem">
            <img src="@/assets/pdf.png" style="width: 100%" alt="" />
          </div>
          <div class="lwContent">
            {{ item.title }}
          </div>
          <div style="font-size:13px;">{{ item.releaseTime }}</div>
        </div>
        <div style="text-align: center">
          <div
            class="moreBtn"
            @click="goAcademic"
            style="margin: 20px auto 10px; font-size: 0.14rem; text-align: center"
          >
            查看更多 →
          </div>
        </div>
      </div>
      <!-- 新闻列表 -->
      <div style="margin-top: 0.3rem; text-align: center">
        <div
          style="
            font-size: 0.34rem;
            line-height: 1.4;
            color: #ddd;
            font-weight: 400;
            font-family: 'Proxima-Bold', sans-serif;
          "
        >
          NEWS CENTER
        </div>
        <div
          style="
            font-size: 0.26rem;
            color: #0f3a3c;
            font-weight: 600;
            margin-top: -4px;
          "
        >
          新闻中心
        </div>
      </div>
      <div style="padding: 0.05rem 0.2rem 0.1rem">
        <div style="margin-top: 0.15rem">
          <div
            v-if="newsListM.length > 0"
            @click="goPhoneNews(newsListM[0].id)"
          >
            <div style="width: 100%; border: 1px solid #ccc">
              <img
                :src="getUrlPrefix(newsListM[0].images)"
                style="width: 100%; height: 2.6rem"
                alt=""
              />
            </div>
            <div
              style="
                border-right: 1px solid #ccc;
                width: 0.4rem;
                margin-top: 0.14rem;
                margin-left: 0.1rem;
              "
            >
              <div style="font-size: 0.24rem; color: #666">
                {{ newsListM[0].releaseTime.slice(5, 7) || "" }}
              </div>
              <div style="font-size: 0.14rem; color: #ccc">
                /{{ newsListM[0].releaseTime.slice(8, 11) || "" }}
              </div>
            </div>
            <div style="font-size: 0.16rem; color: #333; margin-top: 0.05rem">
              {{ newsListM[0].title || "" }}
            </div>
            <div
              style="
                font-size: 0.13rem;
                margin-top: 0.05rem;
                color: #999;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                overflow: hidden;
              "
            >
              {{ newsListM[0].description || "" }}
            </div>
          </div>
          <template v-for="(item, index) of newsListM">
            <div :key="index" v-if="index !== 0" @click="goPhoneNews(item.id)">
              <div
                style="
                  font-size: 0.146rem;
                  margin-top: 0.12rem;
                  border-bottom: 1px dotted #ccc;
                  padding: 0.08rem 0;
                  display: flex;
                  align-items: center;
                "
              >
                <!-- <div
                  style="
                    width: 0.06rem;
                    height: 0.06rem;
                    background: #719468;
                    border-radius: 0.5rem;
                    margin-right: 0.08rem;
                  "
                ></div> -->
                <div style="width: 0.12rem; margin-right: 0.04rem">
                  <img
                    src="@/assets/mobile/img.png"
                    style="width: 100%"
                    alt=""
                  />
                </div>
                <div
                  style="
                    flex: 1;
                    margin-right: 0.1rem;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 1;
                    overflow: hidden;
                  "
                >
                  {{ item.title || "" }}
                </div>
                <div
                  style="width: 0.9rem; text-align: right; font-size: 0.13rem"
                >
                  {{ item.releaseTime || "" }}
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div style="text-align: center">
        <div
          class="moreBtn"
          @click="goNews"
          style="margin: 0 auto; font-size: 0.14rem; text-align: center"
        >
          更多资讯 →
        </div>
      </div>
      <!-- 视频列表 -->
      <div style="margin-top: 0.3rem; text-align: center">
        <div
          style="
            font-size: 0.34rem;
            line-height: 1.4;
            color: #ddd;
            font-weight: 400;
            font-family: 'Proxima-Bold', sans-serif;
          "
        >
          VIDEO CENTER
        </div>
        <div
          style="
            font-size: 0.26rem;
            color: #0f3a3c;
            font-weight: 600;
            margin-top: -4px;
          "
        >
          视频中心
        </div>
      </div>
      <div style="padding: 0.12rem 0.2rem 0.3rem">
        <div
          class="videoList"
          style="
            display: flex;
            justify-content: space-around;
            margin-top: 0.08rem;
          "
        >
          <template v-for="(item, index) of videoList">
            <div style="flex: 1" :key="index" @click="goVideoDetail(item.id)">
              <div
                style="width: 100%; border: 1px solid #ccc; position: relative"
              >
                <img
                  :src="getUrlPrefix(item.coverImage)"
                  style="width: 100%"
                  alt=""
                />
                <img
                  src="@/assets/mobile/video.png"
                  style="width: 70%; position: absolute; top: 10px; left: 15%"
                  alt=""
                />
              </div>
              <div
                style="
                  width: 100%;
                  font-size: 0.14rem;
                  line-height: 1.5;
                  padding: 0.06rem 0;
                  text-align: center;
                  background: #719468;
                  color: #fff;
                  border: 1px solid #719468;
                "
              >
                {{ item.title || "" }}
              </div>
            </div>
          </template>
        </div>
      </div>
      <!-- 一问一答 -->
      <div style="margin-top: 0.1rem; text-align: center">
        <div
          style="
            font-size: 0.34rem;
            line-height: 1.4;
            color: #ddd;
            font-weight: 400;
            font-family: 'Proxima-Bold', sans-serif;
            text-transform:uppercase;
          "
        >
          Q & A
        </div>
        <div
          style="
            font-size: 0.26rem;
            color: #0f3a3c;
            font-weight: 600;
            margin-top: -4px;
          "
        >
          一问一答
        </div>
      </div>
      <div class="wenda">
        <div v-for="(item, index) of QAList" :key="index"
          style="display: flex; padding: 10px 0; border-bottom: 1px solid #ccc" @click="showAll(index)">
          <div class="wenIcon">问</div>
          <div style="flex: 1; position: relative">
            <div class="question">
              <div>
                {{ item.question }}
                <img src="@/assets/landingPage/question-hot-3.png" v-if="index === 0" alt="" />
              </div>
            </div>
            <div style="position: relative;">
              <div class="answer hideAnswer" :id="`answer` + index" style="" v-html="item.answer"></div>
              <div class="wenIcon" style="position:absolute;left:-0.26rem;top:-2px;background:#fc0000;">答</div>
            </div>
            <!-- <div style="position:absolute;right:0px;bottom:0px;font-size:13px;background:#fff;">...展开</div> -->
          </div>
        </div>
      </div>
      <div style="margin-top: 0.3rem; text-align: center">
        <div
          style="
            font-size: 0.34rem;
            line-height: 1.4;
            color: #ddd;
            font-weight: 400;
            font-family: 'Proxima-Bold', sans-serif;
            text-transform:uppercase;
          "
        >
        contact us
        </div>
        <div
          style="
            font-size: 0.26rem;
            color: #0f3a3c;
            font-weight: 600;
            margin-top: -4px;
          "
        >
          联系我们
        </div>
      </div>
      <div class="imagesQrcode">
        <img id="image11" :src="customerQrcode" />
      </div>
      <div class="imageQrcodeText" style="">
        官方客服二维码
      </div>
    </div>
    <footerNav></footerNav>
  </div>
</template>

<script>
import headerNav from "@/components/headerNav/index";
import bannerNav from "@/components/banner/index";
import footerNav from "@/components/footerNav/index";
import {
  getCarouselList,
  homeProductList,
  getNewsList,
  getVideoList,
  getHomeMobileNewsLis,
  getBrandHonors,
  getAcademicList,
} from "@/api/home";
import { getConfByKey } from "@/api/common";
import { getAboutUsListByType } from "@/api/aboutUs";

export default {
  name: "Home",
  components: { headerNav, footerNav, bannerNav },
  data() {
    return {
      info: {
        carousel: [],
        Mcarousel: [],
      }, //轮播图
      advantagesShow: true,
      introduceShow: true,
      techniclaShow: true,
      newsShow: true,
      huobanShow: true,
      productInfo: {}, //产品主题描述
      productList: [], //产品列表数据
      carouselList: [], //合作伙伴列表数据
      kyAdvantages: {}, //科研优势背景图
      zsList: [], //品牌荣誉数据
      lwList: [], //学术论文数据
      brandAdvantagesList: [], //科研优势数据
      transform: {}, //成功应用与转化对象
      newsCarouselList: [],
      newsList: [], //新闻列表数据
      newsListM: [],
      news: {}, //新闻中心对象
      videoList: [], //视频
      newNum: 0,
      timer: null,
      left: 0,
      animalShow: true,
      touchStartX: 0, // 触屏起始点x
      touchStartY: 0, // 触屏起始点y
      delta: 50,
      QAList: [
        {
          question: "1.美白祛斑是即时效果，还是长效？刷酸吗？反黑吗？",
          answer: `御方汇美白祛斑原料是长效，不刷酸，不脱皮，不反黑，没有尴尬期，不借助仪器和技术即可达到美白祛斑的目标。`,
          show: false,
        },
        {
          question: "2.美白祛斑多长时间能有效果？",
          answer: `御方汇美白祛斑原料是通过重建微循环，促微循环，加快新陈代谢，同时抑制黑色素的生成来达到美白祛斑的目标，因为要重建微循环，所以需要时间，一般在使用2周时间可以看到效果，在使用3周时间可以看到显著的效果。`,
          show: false,
        },
        {
          question: "3.御方汇美白祛斑原料适用于什么类型的斑点？",
          answer: `御方汇美白祛斑原料适用于黄褐斑，妊娠斑，色素沉积斑，反黑斑，块状斑，效果显著。`,
          show: false,
        },
        {
          question: "4.原料含有激素，抗生素或违禁成分吗？",
          answer: `黄家圣幸所有的原料确保不含激素，抗生素，农药残留，重金属以及危禁成分等。均可提供第三方报告和并可随时抽检。`,
          show: false,
        },
        {
          question: "5.祛痘有刷酸吗？有用到激素，抗生素吗？",
          answer: `黄家圣幸6号祛痘原料祛痘不刷酸，不含激素，抗生素。主要通过广谱抗炎抗菌，调节面部激素水平，促微循环，修复受损肌肤来达到祛痘目标的。`,
          show: false,
        },
        {
          question: "6.黄家圣幸6号祛痘原料适用于什么类型的痘痘？",
          answer: `黄家圣幸6号祛痘原料主要适用于丘疹型，脓包型，囊肿型，玫瑰型，缔结型等痘痘及粉刺。`,
          show: false,
        },
        {
          question: "7.祛痘需要借助仪器和技术吗？",
          answer: `黄家圣幸6号祛痘原料祛痘修复只需要贴贴面膜，涂抹凝胶即可达到祛痘的目标，不借助作任何仪器和技术。`,
          show: false,
        },
        {
          question: "8.黄家圣幸7号舒缓抗敏原料适用于那些问题肌？",
          answer: `黄家圣幸7号舒缓抗敏原料适用于 敏感肌，皮肤过敏症，皮炎，湿疹，荨麻疹，以及红、肿、热、疼、痒等症状。`,
          show: false,
        },
        {
          question: "9.黄家圣幸7号舒缓抗敏原料抗敏修复需要借助仪器和技术吗？",
          answer: `黄家圣幸7号舒缓抗敏原料抗敏修复只需要贴贴面膜，涂抹凝胶或精华，即可达到舒缓、抗敏、止痒、修复的目标，不需要借助任何仪器和技术，也不含激素，抗生素等违禁成分。`,
          show: false,
        },
      ],
      customerQrcode: "",
    };
  },
  mounted() {
    if (this.isMobile() === false) {
      // this.advantagesShow = true
      // this.introduceShow = true
      // this.newsShow = true
      // this.huobanShow = true
      // this.animalShow = true
      // window.addEventListener('scroll', this.getScroll)
    }
    this.getHomeData();
    if (this.isMobile() === true) {
      window.addEventListener("scroll", this.getScroll1);
      this.postMessage(
        "御方汇植物化妆品原料【官网】",
        document
          .querySelector('meta[name="description"]')
          .getAttribute("content"),
        window.location.href,
        this.getUrlPrefix(this.getBaseInfo().logo)
      );
    }
  },
  methods: {
    // pc端滑动时的动态效果
    getScroll() {
      console.log(this.advantagesShow);
      var advantages = document.getElementById("advantages").offsetTop;
      var introduce = document.getElementById("introduce").offsetTop;
      var news = document.getElementById("news").offsetTop;
      var huoban = document.getElementById("huoban").offsetTop;
      var winHeight = window.innerHeight;
      var headerNav = 0;
      console.log(headerNav);
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // console.log(a)
      if (advantages - headerNav < scrollTop) {
        this.advantagesShow = true;
      }
      if (introduce - headerNav < scrollTop) {
        if (this.introduceShow === false) {
          var that = this;
          this.introduceShow = true;
          setTimeout(() => {
            that.animalShow = false;
            // console.log(that.animalShow)
          }, 2500);
        }
      }
      if (news - headerNav < scrollTop) {
        this.newsShow = true;
      }
      if (huoban - headerNav < scrollTop) {
        this.huobanShow = true;
      }
      if (scrollTop === 0 && !this.isMobile()) {
        this.advantagesShow = false;
        this.introduceShow = false;
        this.newsShow = false;
        this.huobanShow = false;
      }
    },
    // 手机端滑动时的动态效果
    getScroll1() {
      var introduce = document.getElementById("introduceM").offsetTop;
      var technicla = document.getElementById("techniclaM").offsetTop;
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // console.log(document.documentElement.clientHeight)
      // console.log(a)
      var height = scrollTop + document.documentElement.clientHeight;
      if (introduce < height - 50) {
        this.introduceShow = true;
      }
      if (technicla < height - 100) {
        this.techniclaShow = true;
      }
      // var news = document.getElementById('newsM').offsetTop
      // var huoban = document.getElementById('huobanM').offsetTop
      // console.log(introduce,technicla,height)
    },
    goAbout() {
      this.$router.push({ name: "aboutUs" });
    },
    goNews() {
      this.$router.push({ name: "newsCenter" });
    },
    goProduct(){
      this.$router.push({ name: "productCenter" });
    },
    goHonors() {
      this.$router.push({ name: "brandHonors" });
    },
    goVideoList() {
      this.$router.push({ name: "video" });
    },
    goProductDetail(id) {
      this.$router.push({ name: "productCenterDetail", params: { id: id } });
    },
    goVideoDetail(id) {
      this.$router.push({ name: "videoListDetail", params: { id: id } });
    },
    goNewsDetail(id) {
      this.$router.push({ name: "newsDetail", params: { id: id } });
    },
    goLwDetail(obj) {
      if (obj.externalUrl && obj.externalUrl !== "") {
        window.open(obj.externalUrl, "_blank");
      } else {
        this.$router.push({
          name: "academicCenterDetail",
          params: { id: obj.id },
        });
      }
    },
    goAcademic() {
      this.$router.push({ name: "academicCenter" });
    },
    getHomeData() {
      //轮播图
      getCarouselList({ type: 1 }).then((response) => {
        var datas = response.data;
        if (datas) {
          datas.forEach((item) => {
            this.info.carousel.push(this.getUrlPrefix(item.images));
            // this.info.Mcarousel.push(this.getUrlPrefix(item.mobileImages))
          });
        }
      });
      getCarouselList({ type: 3 }).then((response) => {
        var datas = response.data;
        if (datas) {
          datas.forEach((item) => {
            // this.info.carousel.push(this.getUrlPrefix(item.images))
            this.info.Mcarousel.push(this.getUrlPrefix(item.images));
          });
        }
      });
      //产品
      homeProductList().then((response) => {
        var list = response.data.list
        list.forEach((item) => {
          item.name = item.name.replace("（", "<br>（");
          item.name = item.name.replace("(", "<br>(");
        });
        this.productList = list;
      });

      //产品主题描述
      getConfByKey({ key: "sys.index.product.desc" }).then((response) => {
        this.productInfo = response.data;
      });

      //合作伙伴
      getCarouselList({ type: 2 }).then((response) => {
        this.carouselList = response.data;
        this.total = response.data;
      });

      //科研优势背景图
      getConfByKey({ key: "sys.index.scientific.bg" }).then((response) => {
        this.kyAdvantages = response.data;
      });

      //科研优势内容
      getAboutUsListByType({ type: 2 }).then((response) => {
        this.brandAdvantagesList = response.data;
      });

      //御方汇-始于中药世家
      getConfByKey({ key: "sys.index.sumProfile" }).then((response) => {
        this.transform = response.data;
      }),
      //新闻
      getNewsList({ type: 1 }).then((response) => {
        var list = response.data;
        // if(list.carouselList.length === 0){
        //   list.carouselList.push()
        // }
        this.newsCarouselList = list.carouselList;
        this.newNum = 0;
        this.timer = setInterval(() => {
          if (this.newNum === this.newsCarouselList.length - 1) {
            this.newNum = 0;
          } else {
            this.newNum++;
          }
        }, 5000);
        var newsList = [];
        list.list.forEach((item, index) => {
          if (index < 3) {
            newsList.push(item);
          }
        });
        this.newsList = newsList;
        // console.log(this.newsCarouselList)
        // list.forEach((item, index) => {
        //   if (index === 0) {
        //     this.news = item;
        //   }
        //   if (index > 0) {
        //     this.newsList.push(item);
        //   }
        // });
      });
      // 获取手机端行为列表
      getHomeMobileNewsLis({ type: 1 }).then((response) => {
        var list = response.data.list;
        var newsListM = [];
        list.forEach((item, index) => {
          if (index < 4) {
            newsListM.push(item);
          }
        });
        this.newsListM = newsListM;
      });

      //视频中心
      getVideoList({ pageSize: 2 }).then((response) => {
        this.videoList = response.data.list;
      });

      getBrandHonors({ type: 3 }).then((res) => {
        // console.log(res);
        this.zsList = res.data;
      });

      getAcademicList({ type: 4 }).then((res) => {
        // console.log(res);
        this.lwList = res.data;
      });
      
      this.customerQrcode = this.getUrlPrefix(
        this.getBaseInfo().customerQrcode
      );
    },
    // 查看手机新闻
    goPhoneNews(id) {
      this.$router.push({ name: "newsDetail", params: { id: id } });
    },
    // 切换新闻
    switchNews(index) {
      this.newNum = index;
      clearTimeout(this.timer);
      this.timer = setInterval(() => {
        if (this.newNum === this.newsCarouselList.length - 1) {
          this.newNum = 0;
        } else {
          this.newNum++;
        }
      }, 5000);
    },

    // 手机合作伙伴滑动操作
    toLeft() {
      if (this.isMobile() === false) {
        if (this.left < 0) {
          this.left = this.left + 198;
        } else {
          var max = (this.carouselList.length - 6) * 198;
          this.left = 0 - max;
        }
      } else {
        var width = document.getElementsByClassName("hzhb")[0].offsetWidth;
        if (this.left < 0) {
          var left = this.left + width * 2;
          var max = (this.carouselList.length - 3) * (width + 10) - 10;
          if (left > max) {
            this.left = max;
          } else {
            this.left = left;
          }
        } else {
          var max = (this.carouselList.length - 3) * (width + 10);
          this.left = 0 - max;
        }
      }
    },
    toRight() {
      if (this.isMobile() === false) {
        var max = (this.carouselList.length - 6) * 198 - 20;
        if (this.left > 0 - max) {
          this.left = this.left - 198;
        } else {
          this.left = 0;
        }
      } else {
        var width = document.getElementsByClassName("hzhb")[0].offsetWidth;
        var max = (this.carouselList.length - 3) * (width + 10) - 10;
        if (this.left > 0 - max) {
          this.left = this.left - width * 2;
        } else {
          this.left = 0;
        }
      }
    },
    touchStart(e) {
      //  console.log("触摸开始")
      // e.preventDefault && e.preventDefault(); //阻止文字选中等 浏览器默认事件
      this.touchStartX = e.touches[0].clientX;
      this.touchStartY = e.touches[0].clientY;
    },
    touchMove(event) {
      var a = this.touchStartX - event.touches[0].clientX;
      var w = a < 0 ? a * -1 : a;
      if (w > 5) {
        event.preventDefault();
      }
    },
    touchEnd(e) {
      // console.log("触摸结束")
      let deltaX = e.changedTouches[0].clientX - this.touchStartX;
      let deltaY = e.changedTouches[0].clientY - this.touchStartY;
      // console.log(deltaX,deltaY)
      // X轴的滑动距离大于 delta，且此次事件是以X轴移动为主（左滑或者右滑）；
      if (
        Math.abs(deltaX) > this.delta &&
        Math.abs(deltaX) > Math.abs(deltaY)
      ) {
        if (deltaX >= 0) {
          // console.log("右滑")
          this.toLeft();
        } else {
          // console.log("左滑")
          this.toRight();
        }
        // Y轴的滑动距离大于 delta，且此次事件是以Y轴移动为主（上滑或者下滑）；
      } else if (
        Math.abs(deltaY) > this.delta &&
        Math.abs(deltaX) < Math.abs(deltaY)
      ) {
        if (deltaY < 0) {
          // console.log("上滑")
          this.$emit("fingerToT");
        } else {
          // console.log("下滑")
          this.$emit("fingerToB");
        }
        // 两轴位移都特别小，可以判断是点击
      } else if (Math.abs(deltaY) < 25 && Math.abs(deltaX) < 25) {
        // console.log("点击")
      } else {
        // console.log("可能是误触")
      }
    },
    showAll(index) {
      var answerContainer = document.querySelector("#answer" + index);
      if (this.QAList[index].show === false) {
        answerContainer.classList.remove("hideAnswer");
      }
      if (this.QAList[index].show === true) {
        answerContainer.classList.add("hideAnswer");
      }
      this.QAList[index].show = !this.QAList[index].show;
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.getScroll);
    window.removeEventListener("scroll", this.getScroll1);
  },
};
</script>
<style lang="scss">
.homePagePc {
  .maxWidth {
    width: 1286px;
    margin: 0 auto;
  }
  .productNav {
    // display:flex;
    // align-items: center;
    // justify-content: space-around;
    .product {
      transition: border-color 0.3s, background-color 0.3s, color 0.3s;
      width: 387px;
      min-height: 400px;
      position: relative;
      float: left;
      border-radius: 10px;
      margin-right: 60px;
      box-shadow: 0px 2px 6px 0px rgba(63, 107, 51, 0.44);
      margin-bottom: 58px;
    }
    .product:nth-child(3n) {
      margin-right: 0;
    }
    .productText {
      position: absolute;
      bottom: 26px;
      font-size: 23px;
      line-height: 36px;
      font-weight: 400;
      left: 0;
      width: 100%;
      text-align: center;
      .moreBtn {
        background: #3f6b33;
        border-radius: 8px;
        width: 110px;
        height: 34px;
        line-height: 34px;
        margin: 22px auto 0;
        color: #fff;
        font-size: 15px;
        box-shadow: 0px 2px 6px 0px rgba(63, 107, 51, 0.44);
      }
    }
    .product:hover {
      background: #719468;
      .productText {
        color: #fefefe;
        .moreBtn {
          cursor: pointer;
          background: #fff;
          color: #000000;
          box-shadow: 0px 2px 6px 0px rgba(63, 107, 51, 0.44);
        }
      }
    }
  }
  .advantages {
    transition: all 0.5s;
    position: relative;
    .advantagesbg {
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
    }
    .advantages-content {
      height: 487px;
      display: flex;
      align-items: center;
      justify-content: center;
      .advantages-content-img {
        display: flex;
        margin-bottom: 27px;
        > div {
          width: 230px;
          margin-right: 33px;
          margin-top: 37px;
        }
        > div:nth-child(2n) {
          margin-top: 0;
        }
        > div:nth-child(3n) {
          margin-right: 0;
        }
        .img {
          box-shadow: 0px 2px 6px 0px rgba(63, 107, 51, 0.44);
          margin-bottom: 16px;
          border-radius: 16px;
        }
        .img {
          img {
            width: 100%;
            transition: all 0.5s;
          }
        }
        .img:hover {
          img {
            transform: scale(1.05);
          }
        }
        .content {
          text-align: justify;
          font-size: 16px;
        }
      }
    }
  }
  .partners {
    padding: 40px 68px 32px;
    align-items: center;
    display: -webkit-box;
    .partners-img {
      width: 178px;
      background: #fff;
      margin-right: 20px;
      display: flex;
      align-items: center;
      img {
        background: #fff;
      }
    }
    .partners-img:last-child {
      margin-right: 0;
    }
  }
  .newNav {
    .newsCarouse {
      .title {
        margin: 16px 0 12px 0;
        font-size: 18px;
        line-height: 18px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
      }
    }
    .newsCarouseNav:hover {
      .title {
        color: #719468;
      }
    }
    .newList {
      cursor: pointer;
      margin-bottom: 8px;
      padding: 6px 30px;
      .date {
        font-size: 24px;
        line-height: 24px;
        color: #719468;
      }
      .title {
        display: flex;
        align-items: center;
        position: relative;
        margin: 22px 0 16px 0;
        .name {
          color: #000000;
          font-size: 20px;
          cursor: pointer;
          flex: 1;
          line-height: 20px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
        }
      }
      .content {
        font-size: 16px;
        line-height: 24px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
    }
    .newList:last-child {
      margin-bottom: 0;
    }
    .newList:hover {
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
      .name {
        color: #719468;
      }
    }
  }
  .zsBar {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding-bottom: 10px;
    .zs {
      width: 26%;
      padding: 10px 3%;
    }
    .zsText {
      text-align: center;
      padding: 8px;
    }
  }
  .lwList {
    display: flex;
    align-items: center;
    width: 46%;
    padding: 18px 0;
    border-bottom: 1px solid #ccc;
    .lwListTitle {
      cursor: pointer;
    }
    .lwListTitle:hover {
      text-decoration: underline;
    }
  }
  .button1 {
    background: #fff;
    color: #719468;
    border: 1px solid #719468;
  }
  .button1:hover {
    background: #719468;
    color: #fff;
  }
  .button2:hover {
  }
}
.homePageM {
  .productNav {
    padding: 0 0.21rem;
    margin-top: 0.24rem;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: center;
    justify-content: space-between;
    .product {
      transition: border-color 0.3s, background-color 0.3s, color 0.3s;
      width: 48%;
      position: relative;
      border-radius: 10px;
      box-shadow: 0px 2px 6px 0px rgba(63, 107, 51, 0.44);
      margin-bottom: 0.23rem;
    }
    .product:nth-child(2n) {
      margin-right: 0;
    }
    .productText {
      position: absolute;
      bottom: 0.11rem;
      font-size: 0.14rem;
      font-weight: 400;
      left: 0;
      width: 100%;
      text-align: center;
    }
  }
  .zsList {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    zoom: 0.9;
    .img {
      margin-right: 4%;
    }
    .img:nth-child(2n) {
      margin-right: 0;
    }
    .title {
      color: #000000;
      font-size: 14px;
      line-height: 23px;
      text-align: center;
      margin: 22px 0 18px;
    }
  }
  .lwListNav {
    font-size: 14px;
    display: flex;
    align-items: center;
    border-bottom: 1px dotted #ccc;
    margin-top: 0.12rem;
    padding: 0.08rem 0px;
    .lwContent {
      flex: 1;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
    }
  }
  .moreBtn {
    display: inline-block;
    background: linear-gradient(45deg, #7ace63 0%, #3f6b33 100%);
    margin: 0.04rem auto 0;
    padding: 0.03rem 0.08rem;
    color: #fff;
    font-size: 0.12rem;
    box-shadow: 0px 2px 6px 0px rgba(63, 107, 51, 0.44);
  }
  .advantages-content-img {
    display: flex;
    padding: 0.2rem 0.2rem 0.24rem;
    > div {
      flex: 1;
      margin-right: 0.14rem;
      margin-top: 0.16rem;
    }
    > div:nth-child(2n) {
      margin-top: 0;
    }
    > div:last-child {
      margin-right: 0;
    }
    .img img {
      box-shadow: 0px 2px 6px 0px rgba(63, 107, 51, 0.44);
      border-radius: 0.08rem;
    }
  }
  .partners {
    padding: 40px 68px 32px;
    align-items: center;
    display: -webkit-box;
    .partners-img {
      width: 1rem;
      background: #fff;
      margin-right: 0.1rem;
      display: flex;
      align-items: center;
      img {
        background: #fff;
      }
    }
    .partners-img:last-child {
      margin-right: 0;
    }
  }
  .videoList {
    > div {
      margin-right: 0.15rem;
    }
    > div:nth-child(2n) {
      margin-right: 0;
    }
  }
  .wenda {
    padding: 16px;

    .wenIcon {
      background: #44c48d;
      border-radius: 5px;
      padding: 1px 3px;
      margin-right: 5px;
      margin-top: 2px;
      height: max-content;
      font-size: 12px;
      color: #fff;
    }

    .question {
      font-size: 16px;
      color: #333;
      margin-bottom: 10px;
      font-weight: bold;
      display: flex;
      align-items: center;
      line-height: 22px;

      img {
        width: 18px;
        height: 18px;
        margin-top: -4px;
      }
    }

    .answer {
      font-size: 13px;
      color: #666;
    }

    .hideAnswer {
      display: -webkit-box;
      /* 兼容性 */
      -webkit-line-clamp: 2;
      /* 指定显示行数 */
      -webkit-box-orient: vertical;
      /* 文本垂直排列 */
      overflow: hidden;
      /* 多余部分隐藏 */
    }
  }
  .imageQrcodeText {
    font-size: 17px;
    text-align: center;
    margin: 0px auto 10px;
  }
  .imagesQrcode {
    width: 60%;
    margin: 0px auto 0;
    border-radius: 10px;
    img {
      border-radius: 10px;
      width: 100%;
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue